import { render } from "./SellerID.vue?vue&type=template&id=7db0ff7a&ts=true"
import script from "./SellerID.vue?vue&type=script&lang=ts"
export * from "./SellerID.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__